import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

export function useRole() {
  const { user } = useAuth();

  const { data: roles = [], isLoading } = useQuery({
    queryKey: ["user_roles", user?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", user!.id);
      if (error) return [];
      return data.map((r) => r.role);
    },
    enabled: !!user?.id,
    staleTime: 5 * 60 * 1000,
  });

  return {
    roles,
    isAdmin: roles.includes("admin"),
    isLoading,
  };
}
